module.exports = __webpack_public_path__ + "img/pay-processing.50b448b4.png";